/**
 * Adds a link to a correlation.
 *
 * @param {Correlation} correlation
 * @param {Link} link
 */
export function addLink(correlation, link) {
    correlation.link.push(link);
    return correlation;
}
//# sourceMappingURL=addLink.js.map